export const ieo = {
  zzjx: '正在进行',
  rgjl: '认购记录',
  yjjs: '已经结束',
  sf: '首发',
  mjze: '募集总额',
  ckjz: '筹款进展',
  tips_1: 'Biking Startup平台重磅上线，和Biking一同发掘财富密码吧！',
  tips_2: '即将上线优质项目，尽情期待',
  jyjjks: '交易即将开始',
  ksjy: '开始交易',
  qjy: '去交易',
  xmmc: '项目名称',
  xmfjs: '项目方介绍',
  syxm: '所有项目',
  banner_1: '全新推出区块链项目首发平台',
  banner_2: 'Biking一起寻找区块链黑马，开启财富自由之路',
  ywc: '已完成',
  rgsj: '认购时间：',
  zcz: '支持者',
  dqjd: '当前进度',
  yck: '已筹款',
  sddb: '收到代币',
  dff: '待发放',
  zwxm: '暂无项目',
  xq: '详情',
  wksyr: '未开始预热',
  yrz: '预热中',
  jxz: '进行中',
  yjs: '已结束',
  ts: '提示',
  dbwfjy: '该代币暂时无法交易',
  ckqtdb: '请查看其他代币',
  xm: '项目',
  ksrg: '开始认购',
  yrg: '已认购',
  xmjs: '项目介绍',
  csjg: '初始价格',
  dbzl: '代币总量：{amount}枚',
  cssz: '初始市值：{fdv}美金',
  xmcytj: '项目参与条件',
  cjygzh: '创建一个Biking账户',
  yyzh: '已有账户，直接登录',
  dlzhjkcy: '登录账户即可参与认购',
  dljkrg: '登录账户即可认购',
  xhzc: '现货资产',
  zcdy: '现货资产 ≥ 10 USDT',
  rggz: '认购规则',
  rgcg: '认购成功',
  cgrgxm: '恭喜！你已成功认购项目！',
  fhsy: '返回首页',
  cyrghd: '参与Biking Startup 认购活动',
  rgje: '认购金额',
  xhzcgz: '现货资产估值',
  rgsm: '认购说明：',
  rgsm1: '1.个人认购金额为≥{amount1}USDT；≤{amount2}USDT；',
  rgsm2: "2.项目按资金投入比例等比例分配认购，若用户认购金额大于实际分配的金额的代币，认购结束后，剩余的U将返还回现金账户",
  qd: '确定',
  dyr: '待预热',
  rgdjs: '认购倒计时',
  yrdjs: "预热倒计时",
  jykqdjs: '交易开启倒计时',
  qrg: '去认购',
  rgjebdy: '认购金额最少不低于{amount} USDT',
  rgjebgy: '认购金额最多不超过{amount} USDT',
  rgjeccdqjc: '认购金额超出当前资产金额',
  fxts1: "1. 初创项目仍处在初级阶段， 项目的运营、项目的底层技术、法律法规环境等均可能存在极大的风险。",
  fxts2: "2. 了解 Token 并对其固有风险进行评估需要掌握高级的技术和财经知识。",
  fxts3: "3. 受到技术、法律法规、市场和其他因素的影响， 您购买的 Token 价格可能会剧烈波动，价格可能会大幅降低或者升高。",
  fxts4: "4. 由于Token 的底层技术或者BIKING 交易平台的原因， 您购买的 Token 可能无法全部或者部分提现。",
  sfpt: "区块链项目首发平台",
  xmhzsq: "项目合作申请",
  hdlx: "活动类型",
  yryq: "一人一签",
  yrdq: "一人多签",
  hdjg: "活动价格",
  hdsl: "活动数量",
  zqs: "总签数",
  rgqs: "认购签数",
  rgsl: "认购数量",
  mqsl: "每签数量",
  mrzgqs: "每人最高签数",
  qian: "签",
  lian: "链",
  hdrgsm: "认购说明：中签后认购，会根据所有中签用户随机抽取中签总数用户。若认购失败，中签空投发放的同时会退回认购失败使用的USDT。",
  jqqd: "尽情期待中签结果",
  dbffkjy: "代币发放后可交易",
  dzjgb: "待中签公布",
  dzq: "待中签",
  ffzt: "分发状态",
  dbff: "中签代币发放",
  yff: "已发放",
  wzq: "未中签",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/zh.js